import { FC } from 'react';
import { Popup, Radio } from 'antd-mobile';
import styles from './index.less';
import { useModel } from '@@/exports';

interface PaymentInfoProps {
  visible: boolean;
  paymentAmount: string;
  close: (value: boolean) => void;
  discountAmount: number;
}

const PaymentInfo: FC<PaymentInfoProps> = (props) => {
  const { visible, paymentAmount, close, discountAmount } = props;

  const { totalAmount } = useModel('useAccount', (model) => ({
    totalAmount: model.totalAmount,
  }));

  return (
    <Popup
      visible={visible}
      showCloseButton
      bodyClassName={styles['popup-content']}
      onClose={() => close(false)}
    >
      <div className={styles['payment-info']}>
        <div className={styles.divider} />
        <div className={styles.title}>付款金额明细</div>
        <div className={styles['payment-item']}>
          <div className={styles.label}>
            <Radio defaultChecked className={styles['radio']} />
            <span>账户余额</span>
          </div>
          <div className={styles.amount}>¥ {totalAmount}</div>
        </div>
        <div className={styles['payment-item']}>
          <div className={styles.label}>
            <span className={styles['label-title']}>优惠金额</span>
          </div>
          <div className={styles.amount}>¥ {discountAmount}</div>
        </div>
        <div className={styles['payment-item']}>
          <div className={styles.label}>
            <span className={styles['label-title']}>应缴金额</span>
          </div>
          <div className={styles.amount}>¥ {paymentAmount}</div>
        </div>
      </div>
    </Popup>
  );
};
export default PaymentInfo;
